module.exports = "li.pointer i {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 40%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/payment-type/payment-type.component.css
// module id = ./src/app/sendMoney/payment-type/payment-type.component.css
// module chunks = main